import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">内容索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类快速浏览全部影视内容，总有一部适合你</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-50 rounded-lg p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-400/20 hover:-translate-y-1"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${item.icon} text-xl text-primary-400`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-700 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                  <p className="text-xs text-foreground-400 mt-2">
                    <span className="font-semibold text-secondary-400">{item.count}</span> 部作品
                  </p>
                </div>
                <div className="flex-shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}